export const environment = {
  version: '2.52.1',
  production: true,
  api: 'https://api.fleet.uat.meterfeeder.com',

  payments: {
    hpsUrl: 'https://api2.heartlandportico.com',
    cardConnectUrl: 'https://boltgw.cardconnect.com',
    cardConnectMerchantId: '496429030885',
    cardConnectIframeUrl:
      'https://boltgw.cardconnect.com/itoke/ajax-tokenizer.html',
    cardConnectHostedJsUrl: '',
    defaultType: 'fiserv',
  },

  auth0: {
    domain: 'prod-fleet-users.us.auth0.com',
    clientId: 'VlgJHl2x1SyOKtX7QslXt34ePBA7GvAv',
    audience: 'https://prod.meterfeederapp.com',
    redirect_uri: 'https://fleet.uat.meterfeeder.com',
  },
  googleMapsKey: 'AIzaSyCXPKclcalQMJpx5RQDNv1UV14VHjjsSzY',
};

// if (window.location.host === 'fleet.uat.meterfeeder.com') {
//   environment.api = 'https://api.fleet.uat.meterfeeder.com';
//   environment.authRedirect = "https://fleet.uat.meterfeeder.com";
// }
